import React, { useEffect, useRef, useState } from 'react'
import MapContainer from './../../../component/MapContainer'
import { FaMapMarkerAlt, FaPhoneAlt } from 'react-icons/fa'
import Icons from '../../../component/Icons'
import { IoMdMail } from 'react-icons/io'
import emailjs from '@emailjs/browser'
import CloudflareTrustlineReChapcha from '../../../component/CloudflareTrustlineReChapcha'
import { useTranslation } from 'react-i18next'

const ContactsSection = () => {
  const { t } = useTranslation()

  const [contactForm, setContactForm] = useState<Record<string, string>>({
    Name: '',
    EmailAddress: '',
    PhoneNumber: '',
    CompanyName: '',
    TopicOfEnquiry: 'Commoudity Brokerage',
    YourMessage: '',
  })

  const [isVerifed, setIsVerifed] = useState<boolean | null>(null)
  const [isSent, setIsSent] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)

  const inputsSchema: Record<string, {title: string, type: string, required: boolean, options?: string[]}> = {
    Name: {title: t('contacts.name'), type: 'text', required: true},
    EmailAddress: {title: t('contacts.email'), type: 'email', required: true},
    PhoneNumber: {title: t('contacts.phone'), type: 'phone', required: true},
    CompanyName: {title: t('contacts.company'), type: 'text', required: true},
    TopicOfEnquiry: {title: t('contacts.topic'), type: 'select', required: true, options: ['Commoudity Brokerage', 'Freight Brokerage', 'Press & Media Interviews', 'Career Opportunities', 'Other Questions']},
    YourMessage: {title: t('contacts.message'), type: 'textarea', required: false},
  }

  const form = useRef<HTMLFormElement>(null)

  const sendEmail = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    // if (isVerifed) {
    //   if (form.current) {
    //     setIsLoading(true)

    //     await emailjs
    //       .sendForm('service_yfa4tqt', 'template_r72su6l', form.current, {
    //         publicKey: 'r-a4WdmKt1jr0njGg',
    //       })
    //       .then(
    //         () => {
    //           setIsLoading(false)
    //           setIsSent(true)
    //           setIsError(false)
    //         },
    //         (error) => {
    //           setIsLoading(false)
    //           setIsError(true)
    //         }
    //       )
    //   } else {
    //     setIsLoading(false)
    //   }
    // } else {
    //   console.log('Please complete reCAPTCHA verification!')
    // }
  }

  const changeContactForm = (fieldName: string, value: string) => {
    setContactForm({ ...contactForm, [fieldName]: value })
  }

  useEffect(() => {
    if (isSent) {
      const timer = setTimeout(() => {
        setIsSent(false)
      }, 5000)

      return () => clearTimeout(timer)
    }
  }, [isSent])

  return (
    <section className='contacts-section'>
      <div className='title'>
        <h1>{t('contacts.title')}</h1>
      </div>

      <div className='contacts'>
        <div className='location'>
          <div className='map'>
            <MapContainer position={[51.505, -0.09]} />
          </div>
          <div className='contacts-data'>
            <div className='phone'>
              <FaPhoneAlt size={25} />
              <span>+43 664 1531 501 Tanja Kaiser</span>
            </div>
            <div className='phone'>
              <FaPhoneAlt size={25} />
              <span>+43 664 1323 558 Jan Kaiser</span>
            </div>
            <div className='phone'>
              <IoMdMail size={20} />
              <span>dan3trading@dan3trading.com</span>
            </div>
            <div className='phone'>
              <FaMapMarkerAlt size={20} />
              <span style={{ whiteSpace: 'pre-wrap' }}>
                {`St. Veiter Straße 101, 9020 KLAGENFURT, Österreich`}
              </span>
            </div>
            <div className='phone font-medium pt-2'>
              <span>FN 684862 a | UID: AT U83574428</span>
            </div>
            <div className='phone flex flex-col !items-start text-sm pt-2 text-gray-700'>
              <span className='font-semibold'>Kärntner Sparkasse Aktiengesellschaft</span>
              <span>IBAN: AT49 2070 6047 0017 0980</span>
              <span>BIC / SWIFT: KSPKAT2KXXX</span>
            </div>
          </div>
        </div>

        <form ref={form} onSubmit={(e) => sendEmail(e)} className='contact-form'>
          {Object.keys(contactForm).map((field, i) => {
            const fieldSchema = inputsSchema[field]

            switch (fieldSchema.type) {
              case 'text':
              case 'email':
              case 'phone':
                return (
                  <div className='field' key={i}>
                    <input
                      className='input'
                      placeholder={fieldSchema.title}
                      name={Object.keys(inputsSchema)[i]}
                      value={contactForm[field]}
                      type={fieldSchema.type}
                      onChange={(e) => changeContactForm(field, e.target.value)}
                      required
                    />
                  </div>
                )

              case 'select':
                return (
                  <div className='field' key={i}>
                    <span>{fieldSchema.title}</span>
                    <select
                      className='input' 
                      value={contactForm[field]}
                      name={Object.keys(inputsSchema)[i]}
                      onChange={(e) => changeContactForm(field, e.target.value)}
                    >
                      {fieldSchema.options?.map((option, i) => (
                        <option key={i} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </div>
                )
              case 'textarea':
                return (
                  <div className='field' key={i}>
                    <span>{fieldSchema.title}</span>
                    <textarea
                      name={Object.keys(inputsSchema)[i]}
                      className='input'
                      cols={30}
                      rows={5}
                      value={contactForm[field]}
                      onChange={(e) => changeContactForm(field, e.target.value)}
                    />
                  </div>
                )
            }
          })}

          {/* <CloudflareTrustlineReChapcha setIsVerifed={setIsVerifed} /> */}

          {/* {isVerifed === false && (
            <span className='text-red-500'>
              {t('contacts.recaptcha_error')}
            </span>
          )} */}

          <button
            className={`
              send-btn 
              ${
                isLoading
                  ? '!text-white animate-pulse !bg-blue-500'
                  : isError
                  ? '!bg-red-500 !text-white'
                  : isSent
                  ? '!bg-green-600 !text-white'
                  : ''
              }
            `}
          >
            {isLoading
              ? t('contacts.loading')
              : isError
              ? t('contacts.error')
              : isSent
              ? t('contacts.success')
              : t('contacts.send')}
          </button>
        </form>
      </div>
    </section>
  )
}

export default ContactsSection
